import { DateTime } from 'luxon';
import { useState, useCallback } from 'react';
import { INewsMakerItemCreateDTO } from "../../../libs/coreapi-dto/service/newsChat";

export const useNewsMaker = (initialNews: INewsMakerItemCreateDTO) => {
    const [news, setNews] = useState<INewsMakerItemCreateDTO>(initialNews);

    // Базовые функции обновления
    const updateNewsField = useCallback(<K extends keyof INewsMakerItemCreateDTO>(
        field: K,
        value: INewsMakerItemCreateDTO[K]
    ) => {
        setNews(prev => ({ ...prev, [field]: value }));
    }, []);

    const updateSubject = (subject: string) => updateNewsField('subject', subject);
    const updateDescription = (description: string) => updateNewsField('description', description);
    const updateStartDate = (startDate: DateTime | null) => updateNewsField('startDate', startDate);
    const updateDueDate = (dueDate: DateTime | null) => updateNewsField('dueDate', dueDate);
    const updateEstimatedHour = (estimatedHour: number) => updateNewsField('estimatedHour', estimatedHour);
    const updatePriority = (priority: number) => updateNewsField('priority', priority);

    return {
        news,
        updateSubject,
        updateDescription,
        updateStartDate,
        updateDueDate,
        updateEstimatedHour,
        updatePriority,
    };
};